import { render, staticRenderFns } from "./AppScreen.vue?vue&type=template&id=08dff577&scoped=true"
import script from "./AppScreen.vue?vue&type=script&lang=js"
export * from "./AppScreen.vue?vue&type=script&lang=js"
import style0 from "./AppScreen.vue?vue&type=style&index=0&id=08dff577&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dff577",
  null
  
)

export default component.exports